<template>
  <div>
    <custom-callout
      :has-toggle="false"
      :opened="isExpanded"
      :controlled="true"
      :border-color-hex="getDefaultStatusColor"
      @click:open="expand()"
    >
      <div class="row">
        <div
          class="border-right col-sm-12 col-md-3 col-lg-2 py-3  d-flex flex-column align-items-start justify-content-start"
        >
          <div
            :class="
              `badge badge-pill font-16 mt-3 py-2 w-100 mx-auto color-black`
            "
            :style="{ 'background-color': getDefaultStatusColor }"
          >
            {{ item.statusName }}
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-8 py-md-3 py-2 pl-md-5 pl-2">
          <div class="row">
            <div class="col-sm  d-flex flex-column">
              <CustomInputDisplay
                label="Nombre:"
                label-class="text-gray font-weight-light"
                :value="item.fullName"
                class="text-black font-weight-bold "
              />
            </div>
            <div class="col-sm  d-flex flex-column">
              <CustomInputDisplay
                label="Municipio / Escuela:"
                label-class="text-gray font-weight-light"
                :value="item.municipality + ' - ' + item.school"
                class="text-black font-weight-bold "
              />
            </div>
            <div class="col-sm  d-flex flex-column">
              <CustomInputDisplay
                label="Año Escolar:"
                label-class="text-gray font-weight-light"
                :value="item.academicYear"
                class="text-black font-weight-bold "
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-4  d-flex flex-column">
              <CustomInputDisplay
                label="Número de SIE:"
                label-class="text-gray font-weight-light"
                :value="item.studentSie"
                class="text-black font-weight-bold "
              />
            </div>

            <div class="col-sm  d-flex flex-column">
              <CustomInputDisplay
                label="Tipo:"
                label-class="text-gray font-weight-light"
                :value="item.type"
                class="text-black font-weight-bold "
              />
            </div>
            <div
              v-if="item.exitReason != '' && item.exitReason != null"
              class="col-sm  d-flex flex-column"
            >
              <CustomInputDisplay
                label="Razón de Egreso:"
                label-class="text-gray font-weight-light"
                :value="item.exitReason"
                class="text-black font-weight-bold "
              />
            </div>
          </div>
        </div>
        <div
          class="col-md-2 col-sm-12 d-flex align-items-center justify-content-center"
        >
          <DropDown
            class="actions-dropdown pt-2 pr-4"
            :items="getMenuItems"
            normal-size
            :always-show-dropdown="true"
          />
        </div>
      </div>
      <template #edition>
        <template>
          <replace
            v-if="showReplaceSAEE12Discussion"
            :transitionStudentSAEE12Id="item.id"
            :min-date="someMinDate"
            @onClose="(newDocumentId) => onClose(newDocumentId)"
          />
        </template>
        <template v-if="isShowSignedDocumentOpened">
          <discussion
            :transitionStudentSAEE12Id="item.id"
            :min-date="someMinDate"
            :component-name="
              is12 ? 'Documento Firmado SAEE-12' : 'Documento Firmado SAEE-12a'
            "
            @onClose="(newDocumentId) => onClose(newDocumentId)"
          />
        </template>
        <template v-if="isCancelOpened">
          <div class="bg-gray p-2">
            <div class="bg-light-gray rounded pt-1 pl-2 pr-2 pb-2">
              <div class="bg-white rounded mt-1 px-4 py-2">
                <ValidationObserver ref="cancellationForm">
                  <div class="row">
                    <div class="col-12">
                      <ValidationProvider
                        v-slot="{ errors }"
                        mode="eager"
                        rules="required"
                      >
                        <custom-text-area
                          v-model="cancellationReason"
                          :clearable="false"
                          custom-error-msg="La razón es requerida."
                          :error="errors[0]"
                          label="Razón para cancelar:"
                          :maxlength="3000"
                          show-char-count
                          :count-classes="['d-block text-right']"
                          :rows="2"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-12 mt-3 d-flex justify-content-end">
                      <action-button
                        class="ml-2 px-4 mb-3"
                        variant="outline-danger"
                        i="fas fa-times-circle"
                        text="Cancelar"
                        @click="
                          () => {
                            cancellationReason = null;
                            isExpanded = false;
                          }
                        "
                      />
                      <action-button
                        type="button"
                        text="Guardar"
                        i="fas fa-save"
                        variant="success"
                        class="ml-2 px-4 mb-3"
                        @click="onCancelTransition()"
                      />
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </template>
        <template v-if="isHistoryOpened">
          <div class="bg-gray p-2">
            <div class="bg-light-gray rounded pt-1 pl-2 pr-2 pb-2">
              <div class="bg-white rounded mt-1 px-4 py-2">
                <status-timeline
                  @close="calloutMode = null"
                  :history="collections.historyResult"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-if="isReturnStatusOpened">
          <div class="bg-gray p-2">
            <div class="bg-light-gray rounded pt-1 pl-2 pr-2 pb-2">
              <div class="bg-white rounded mt-1 px-4 py-2">
                <ValidationObserver ref="returnStatusForm">
                  <div class="row">
                    <div class="col-12">
                      <ValidationProvider
                        v-slot="{ errors }"
                        mode="eager"
                        rules="required"
                      >
                        <custom-text-area
                          v-model="returnStatusReason"
                          :clearable="false"
                          custom-error-msg="La razón de cambio de estatus es requerida."
                          :error="errors[0]"
                          label="Razón de cambio de estatus:"
                          :maxlength="3000"
                          show-char-count
                          :count-classes="['d-block text-right']"
                          :rows="2"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-12 mt-3 d-flex justify-content-end">
                      <action-button
                        class="ml-2 px-4 mb-3"
                        variant="outline-danger"
                        i="fas fa-times-circle"
                        text="Cancelar"
                        @click="
                          () => {
                            returnStatusReason = null;
                            isExpanded = false;
                          }
                        "
                      />
                      <action-button
                        type="button"
                        text="Guardar"
                        i="fas fa-save"
                        variant="success"
                        class="ml-2 px-4 mb-3"
                        @click="saveReturnStatusReason"
                      />
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </template>
        <template v-if="isChangeNewStatusOpened">
          <div class="bg-gray p-2">
            <div class="bg-light-gray rounded pt-1 pl-2 pr-2 pb-2">
              <div class="bg-white rounded mt-1 px-4 py-2">
                <ValidationObserver ref="returnStatusForm">
                  <div class="row">
                    <div class="col-12">
                      <ValidationProvider
                        v-slot="{ errors }"
                        mode="eager"
                        rules="required"
                      >
                        <custom-text-area
                          v-model="changeNewStatusComment"
                          :clearable="false"
                          custom-error-msg="Favor de documentar el comentario."
                          :error="errors[0]"
                          label="Comentario:"
                          :maxlength="3000"
                          show-char-count
                          :count-classes="['d-block text-right']"
                          :rows="2"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-12 mt-3 d-flex justify-content-end">
                      <action-button
                        class="ml-2 px-4 mb-3"
                        variant="outline-danger"
                        i="fas fa-times-circle"
                        text="Cancelar"
                        @click="
                          () => {
                            changeNewStatusComment = null;
                            isExpanded = false;
                          }
                        "
                      />
                      <action-button
                        type="button"
                        text="Guardar"
                        i="fas fa-save"
                        variant="success"
                        class="ml-2 px-4 mb-3"
                        @click="saveChangeNewStatus"
                      />
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </template>
      </template>
    </custom-callout>
  </div>
</template>

<script>
const CALLOUT_MODES = {
  CANCEL: 'CANCEL',
  HISTORY: 'HISTORY',
  RETURN_STATUS: 'RETURN_STATUS',
  ATTACH_SIGNED_DOCUMENT: 'ATTACH_SIGNED_DOCUMENT',
  REPLACE_SIGNED_DOCUMENT: 'REPLACe_SIGNED_DOCUMENT',
  CHANGE_NEW_STATUS: 'CHANGE_NEW_STATUS',
};
const SAEE12Statuses = Object.freeze({ New: 1, Submitted: 2, Canceled: 3 });
import CustomCallout from 'custom-callout';
import StatusTimeline from './students/components/StatusTimeline';
import CustomInputDisplay from 'CustomInputDisplay';
import DropDown from 'dropdown';
import moment from 'moment';
import CustomBalloon from 'custom-balloon';
import { Colors } from '@/components/common';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import transitionStudentService from '@/services/pei/transitionStudent.js';
import Discussion from '@/components/pei/transition-student/saee-12a/components/PeiTransitionStudentSAEE12Document'; // Adjust the path as necessary
import Replace from '@/components/pei/transition-student/saee-12a/components/ReplacePeiTransitionStudentSAEE12Document';
import store from '@/store/index';
import { transitionStudentTypes } from '@/utils/constants/pei/transition-student/transitionStudentTypes';
import _generalService from '@/services/pei/general';
import reportService from '@/services/report';

const SAEE_12A_ROUTE = 'transition-student-saee-12a';
const SAEE_12_ROUTE = 'transition-student-saee-12';
export default {
  components: {
    StatusTimeline,
    CustomCallout,
    CustomInputDisplay,
    DropDown,
    CustomBalloon,
    CustomTextArea,
    Discussion,
    Replace,
    ActionButton,
  },
  mixins: [mixAlert, mixWait],
  data() {
    return {
      CALLOUT_MODES,
      calloutMode: null,
      isExpanded: false,
      cancellationReason: null,
      returnStatusReason: null,
      changeNewStatusComment: null,
      showSAEE12Discussion: false,
      showReplaceSAEE12Discussion: false,
      showAttachSignedDocument: false,
      collections: {
        historyResult: [],
      },
    };
  },
  props: {
    item: {
      type: Object,
    },
    search: {
      type: Function,
      default: () => undefined,
    },
    academicYear: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    activeIndex: {
      type: Number,
      default: null,
    },
    type: {
      type: Number,
      default: null,
    },
  },
  computed: {
    hasCancelPermission() {
      return store.getters.HasPermission(
        'pei.transitionstudent.canceltransition'
      );
    },
    hasReturnStatusPermission() {
      return store.getters.HasPermission(
        'pei.transitionstudent.returnstatustransition'
      );
    },
    isShowSignedDocumentOpened() {
      return CALLOUT_MODES.ATTACH_SIGNED_DOCUMENT === this.calloutMode;
    },
    isShowReplaceSignedDocumentOpened() {
      return CALLOUT_MODES.REPLACE_SIGNED_DOCUMENT === this.calloutMode;
    },
    isCancelOpened() {
      return CALLOUT_MODES.CANCEL === this.calloutMode;
    },
    isHistoryOpened() {
      return CALLOUT_MODES.HISTORY === this.calloutMode;
    },
    isReturnStatusOpened() {
      return CALLOUT_MODES.RETURN_STATUS === this.calloutMode;
    },
    isChangeNewStatusOpened() {
      return CALLOUT_MODES.CHANGE_NEW_STATUS === this.calloutMode;
    },
    getDefaultStatusColor() {
      return this.item.statusColor == '' ? Colors.GRAY : this.item.statusColor;
    },
    addressedTo() {
      return this.item.isIndividual ? 'Estudiante' : 'Grupo';
    },
    dateFormat() {
      return moment(this.item.date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    getMenuItems() {
      let result = [
        {
          label: `Entrar`,
          icon: 'fas fa-file-import text-green',
          click: () => this.handlerGoTo(),
        },
        {
          label: `Historial de SAEE-12${this.is12a ? 'a' : ''}`,
          icon: 'fas fa-clock text-green',
          click: () => this.showHistory(),
        },
      ];
      if (this.item.documentId) {
        result.push({
          label: 'Descargar Documento',
          icon: 'fas fa-print text-green',
          click: () => this.onDownloadFile(),
        });
      }
      const printableStatuses = [SAEE12Statuses.Submitted, SAEE12Statuses.New];
      const canPrint = printableStatuses.includes(this.item.statusId);
      if (canPrint) {
        if (this.is12 || this.is12a) {
          result.push({
            label: `Imprimir`,
            icon: 'fas fa-print text-green',
            click: () => this.print(),
          });
        }

        if (this.item.statusId == SAEE12Statuses.Submitted) {
          if (this.item.documentId) {
            result.push({
              label: `Reemplazar Documento Firmado`,
              icon: 'fas fa-repeat text-green',
              click: () => this.showReplaceSignedDocumentSection(),
            });
          } else {
            result.push({
              label: `Adjuntar Documento Firmado`,
              icon: 'fas fa-upload text-green',
              click: () => this.showAttachSignedDocumentSection(),
            });
          }
        }
      }
      if (
        this.item.statusId != SAEE12Statuses.Canceled &&
        this.hasCancelPermission
      ) {
        result.push({
          label: `Cancelar`,
          icon: 'fas fa-times-circle text-red',
          class: 'border-top',
          click: () => this.handlerCancel(),
        });
      }

      if (this.canReturnLastStatus) {
        result.push({
          label: `Regresar a Estatus Anterior`,
          icon: 'fas fa-reply text-green',
          click: () => this.handlerReturnStatus(),
        });
      }

      if (
        (this.item.statusId == SAEE12Statuses.Submitted ||
          this.item.statusId == SAEE12Statuses.Canceled) &&
        store.getters.HasPermission('pei.transitionstudent.returnstatusnew')
      ) {
        result.push({
          label: `Cambiar a Nuevo`,
          icon: 'fas fa-reply text-green',
          click: () => this.handleChangeNewStatus(),
        });
      }

      return result;
    },
    is12a() {
      return this.type == transitionStudentTypes.Saee12A;
    },
    is12() {
      return this.type == transitionStudentTypes.Saee12;
    },
    canReturnLastStatus() {
      return this.hasReturnStatusPermission && this.item.hasLogs;
    },
  },
  methods: {
    async getHistory() {
      await transitionStudentService
        .getStatusLog({ id: this.item.id })
        .then((res) => {
          this.collections.historyResult = res.data;
        });
    },
    handlerGoTo() {
      const { id, peiId } = this.item;
      if (this.is12) this.$router.push({ name: SAEE_12_ROUTE, params: { id } });
      else if (this.is12a)
        this.$router.push({ name: SAEE_12A_ROUTE, params: { id, peiId } });
    },
    expand() {
      this.isExpanded = !this.isExpanded;
    },
    showHistory() {
      this.getHistory();
      this.isExpanded = true;
      this.calloutMode = CALLOUT_MODES.HISTORY;
    },
    showReplaceSignedDocumentSection() {
      this.isExpanded = true;
      this.calloutMode = CALLOUT_MODES.ATTACH_SIGNED_DOCUMENT;
    },
    showAttachSignedDocumentSection() {
      this.isExpanded = true;
      this.calloutMode = CALLOUT_MODES.ATTACH_SIGNED_DOCUMENT;
    },
    onDownloadFile() {
      _generalService.getDocument(this.item.documentId);
    },
    onClose(newDocumentId) {
      this.calloutMode = null;
      if (newDocumentId != null && newDocumentId != undefined) {
        this.item.documentId = newDocumentId;
        this.$emit('refreshSearchResults');
      }
    },
    async handlerCancel() {
      let isConfirmed = await this.ShowCancelModal(
        '',
        '¿Está seguro que desea proceder con la cancelación de la SAEE-12a? </b> ',
        'Sí',
        'No'
      );

      if (isConfirmed) {
        this.isExpanded = true;
        this.calloutMode = CALLOUT_MODES.CANCEL;
      }
    },
    async onCancelTransition() {
      var isValid = await this.$refs.cancellationForm.validate();
      if (isValid) {
        transitionStudentService
          .cancelSAEE12({ id: this.item.id, reason: this.cancellationReason })
          .then(() => {
            this.isExpanded = false;
            this.cancellationReason = null;
            this.$emit('refreshSearchResults');
          })
          .catch((err) => {
            this.ShowToast(
              'Alerta',
              'Ha ocurrido un error inesperado.',
              'error'
            );
          });
      }
    },
    async handlerReturnStatus() {
      const answer = await this.ShowCancelModal(
        'Atención',
        `¿Está seguro que desea proceder con el cambio de estatus de la SAEE-12${
          this.is12a ? 'a?</b>' : '?</b>'
        }`,
        'Sí',
        'No'
      );
      if (!answer) return;

      this.isExpanded = true;
      this.calloutMode = CALLOUT_MODES.RETURN_STATUS;
    },
    async handleChangeNewStatus() {
      this.isExpanded = true;
      this.calloutMode = CALLOUT_MODES.CHANGE_NEW_STATUS;
    },
    async saveReturnStatusReason() {
      const valid = await this.$refs.returnStatusForm.validate();
      if (!valid) return;
      try {
        await transitionStudentService.returnStatusSAEE12({
          id: this.item.id,
          reason: this.returnStatusReason,
        });

        this.ShowToast(
          '',
          'Cambio de estatus realizado exitosamente.',
          'success'
        );
        this.isExpanded = false;
        this.returnStatusReason = null;
        this.$emit('refreshSearchResults');
      } catch (error) {
        this.ShowToast('Alerta', 'Ha ocurrido un error inesperado.', 'error');
      }
    },
    async saveChangeNewStatus() {
      const valid = await this.$refs.returnStatusForm.validate();
      if (!valid) return;

      try {
        await transitionStudentService.changeToNewStatusSaee12({
          id: this.item.id,
          comment: this.changeNewStatusComment,
        });

        this.ShowToast(
          '',
          'Cambio de estatus realizado exitosamente.',
          'success'
        );
        this.isExpanded = false;
        this.changeNewStatusComment = null;
        this.$emit('refreshSearchResults');
      } catch (error) {
        this.ShowToast('Alerta', 'Ha ocurrido un error inesperado.', 'error');
      }
    },
    async print() {
      await reportService.downloadSaee12(this.item.id);
    },
  },
  mounted() {
    this.isExpanded = false;
  },
};
</script>

<style scope></style>
